import DOMPurify from "dompurify";

/** Safe HTML for dangerouslySetInnerHTML, XSS protected. */
export const safeHtml = (dirty) => ({
  __html: DOMPurify.sanitize(dirty || "", {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "b", "i", "a", "ul", "ol", "li",
      "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "code", "pre",
      "img", "figure", "figcaption", "span", "div", "hr", "table", "thead",
      "tbody", "tr", "td", "th",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "title", "class"],
    ALLOW_DATA_ATTR: false,
  }),
});
